import { Injectable, Inject, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataList } from 'src/app/shared/models/DataList';
import {
    ICaptureType,
    ICountry,
    IEvent,
    IEventNotifactionDaysToTrigger,
    IFrequency,
    IListType,
    ISpecies
} from 'src/app/layouts/secure/settings/supply-chain/accounts/interfaces/accounts-interface';
import {catchError} from 'rxjs/internal/operators/catchError';
import {throwError} from 'rxjs/internal/observable/throwError';
import {Observable} from 'rxjs/internal/Observable';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {Test} from "./models/Test";
import { EventMessage } from './models/EventMessage';
import { Event } from './models/Event';
import { ImageFile } from "src/app/shared/models/imageFile";
import { Region } from './models/Region';
import { Timezone } from './models/Timezone';
import {Currency} from "./models/Currency";
import { NavServiceService } from "../../../../shared/services/nav-service.service";
import {ActivatedRoute} from "@angular/router";
import {ObjectHolder} from "../../../../shared/models/objectHolder";
import {ExampleImage} from "./models/ExampleImage";
import {SpeciesParticle} from "./models/Particle";
import { Provider } from './countries/selected/providers/models/Provider';
import { PostTreatmentCalculator } from 'src/app/shared/models/PostTreatmentCalculator';


@Injectable({
    providedIn: 'root'
})
export class SharedDataService {

    myAppUrl = '';
    _data: any;

    constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string, private _navService: NavServiceService) {
        this.myAppUrl = baseUrl;
    }
    
    public async checkRouteIDs(route: ActivatedRoute, groupId, siteId) {
        var eventIdParam = route.snapshot.paramMap.get("eventId");

        if (parseInt(eventIdParam)) {
            await this.selectEventById(parseInt(eventIdParam), groupId, siteId);
        }
    }
    
    public get getSelectedCountryId() {
        return this._navService.selectedAccounts.getSelectedCountryId;
    }
    
    public get getSelectedCountryName() {
        return this._navService.selectedAccounts.getSelectedCountryName;
    }

    public setSelectedCountry(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedCountry(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedCountry() {
        if (this._navService.selectedAccounts.getSelectedCountryId) {
            this._navService.selectedAccounts.clearSelectedCountry()
            this._navService.updateNavCounts();
        }
    }
    
    public get getSelectedEventId() {
        return this._navService.selectedAccounts.getSelectedEventId;
    }
    
    public get getSelectedEventName() {
        return this._navService.selectedAccounts.getSelectedEventName;
    }

    public setSelectedEvent(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedEvent(id, name);
    }

    public clearSelectedEvent() {
        if (this._navService.selectedAccounts.getSelectedEventId) {
            this._navService.selectedAccounts.clearSelectedEvent();
        }
    }
    
    public get getSelectedGroupEventId() {
        return this._navService.selectedAccounts.getSelectedGroupEventId;
    }
    
    public get getSelectedGroupEventName() {
        return this._navService.selectedAccounts.getSelectedGroupEventName;
    }

    public setSelectedGroupEvent(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedGroupEvent(id, name);
    }

    public clearSelectedGroupEvent() {
        if (this._navService.selectedAccounts.getSelectedGroupEventId) {
            this._navService.selectedAccounts.clearSelectedGroupEvent();
        }
    }

    public get getSelectedSampleIssueId() {
       return this._navService.selectedAccounts.getSelectedSampleIssueId;
    }

    public get getSelectedSampleIssueName() {
       return this._navService.selectedAccounts.getSelectedSampleIssueName;
   }

   private selectedSampleIssueIsOther: boolean = false;

   public get getSelectedSampleIssueIsOther() {
      return this.selectedSampleIssueIsOther;
   }

    public async setSelectedSampleIssue(id: number, name: string) {
       this._navService.selectedAccounts.setSelectedSampleIssue(id, name);
       this.selectedSampleIssueIsOther = await firstValueFrom(this.sampleIssueIsOther());
       this._navService.updateNavCounts();
    }

    public clearSelectedSampleIssue() {
       if (this._navService.selectedAccounts.getSelectedSampleIssueId) {
          this._navService.selectedAccounts.clearSelectedSampleIssue();
          this._navService.updateNavCounts();
        }
    }

    public get getSelectedSiteEventId() {
        return this._navService.selectedAccounts.getSelectedSiteEventId;
    }
    
    public get getSelectedSiteEventName() {
        return this._navService.selectedAccounts.getSelectedSiteEventName;
    }

    public setSelectedSiteEvent(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedSiteEvent(id, name);
    }

    public clearSelectedSiteEvent() {
        if (this._navService.selectedAccounts.getSelectedSiteEventId) {
            this._navService.selectedAccounts.clearSelectedSiteEvent();
        }
    }
    
    public get getSelectedSpeciesId() {
        return this._navService.selectedAccounts.getSelectedSpeciesId;
    }

    public get getSelectedSpeciesName() {
        return this._navService.selectedAccounts.getSelectedSpeciesName;
    }

    public setSelectedSpecies(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedSpecies(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedSpecies() {
        if (this._navService.selectedAccounts.getSelectedSpeciesId) {
            this._navService.selectedAccounts.clearSelectedSpecies();
            this._navService.updateNavCounts();
        }
   }

   public get getSelectedSeasonId() {
      return this._navService.selectedAccounts.getSelectedSeasonId;
   }

    public get getSelectedSeasonName() {
        return this._navService.selectedAccounts.getSelectedSeasonName;
    }

    public setSelectedSeason(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedSeason(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedSeason() {
        if (this._navService.selectedAccounts.getSelectedSeasonId) {
            this._navService.selectedAccounts.clearSelectedSeason();
            this._navService.updateNavCounts();
        }
    }
    
    public get getSelectedProductId() {
        return this._navService.selectedAccounts.getSelectedProductId;
    }
    
    public get getSelectedProductName() {
        return this._navService.selectedAccounts.getSelectedProductName;
    }

    private selectedProductCanWhiteLabel: boolean = false;

    public get getSelectedProductCanWhiteLabel() {
        return this.selectedProductCanWhiteLabel;
    }

    public async setSelectedProduct(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedProduct(id, name);
        this.selectedProductCanWhiteLabel = await firstValueFrom(this.canProductWhiteLabel());
        this._navService.updateNavCounts();
    }

    public clearSelectedProduct() {
        if (this._navService.selectedAccounts.getSelectedProductId) {
            this._navService.selectedAccounts.clearSelectedProduct();
            this.selectedProductCanWhiteLabel = false;
            this._navService.updateNavCounts();
        }
    }
    
    public get getSelectedParticleId() {
        return this._navService.selectedAccounts.getSelectedParticleId;
    }
    
    public get getSelectedParticleName() {
        return this._navService.selectedAccounts.getSelectedParticleName;
    }

    private selectedParticleCanWhiteLabel: boolean = false;

    public get getSelectedParticleCanWhiteLabel() {
        return this.selectedParticleCanWhiteLabel;
    }

    public async setSelectedParticle(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedParticle(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedParticle() {
        if (this._navService.selectedAccounts.getSelectedParticleId) {
            this._navService.selectedAccounts.clearSelectedParticle();
            this._navService.updateNavCounts();
        }
    }
    
    public get getSelectedParticleGroupId() {
        return this._navService.selectedAccounts.getSelectedParticleGroupId;
    }
    
    public get getSelectedParticleGroupName() {
        return this._navService.selectedAccounts.getSelectedParticleGroupName;
    }

    private selectedParticleGroupCanWhiteLabel: boolean = false;

    public get getSelectedParticleGroupCanWhiteLabel() {
        return this.selectedParticleGroupCanWhiteLabel;
    }

    public async setSelectedParticleGroup(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedParticleGroup(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedParticleGroup() {
        if (this._navService.selectedAccounts.getSelectedParticleGroupId) {
            this._navService.selectedAccounts.clearSelectedParticleGroup();
            this._navService.updateNavCounts();
        }
    }

    async selectEventById(eventId: number, groupId, siteId) {
        if (location.pathname.indexOf('/settings/supply-chain/sites') > -1) {
            var result = await firstValueFrom(this._http.post<any>(`api/SharedDataManagement/GetSiteEventNameById`, {item1: eventId, item2: siteId}).pipe(catchError(this.handleError)));
            if (result) {
                await this.setSelectedSiteEvent(result.item1, result.item2);
            }
        } else if (location.pathname.indexOf('/settings/supply-chain/groups') > -1) {
            var result = await firstValueFrom(this._http.post<any>(`api/SharedDataManagement/GetGroupEventNameById`, {item1: eventId, item2: groupId}).pipe(catchError(this.handleError)));
            if (result) {
                await this.setSelectedGroupEvent(result.item1, result.item2);
            }
        } else {
            var result = await firstValueFrom(this._http.post<any>(`api/SharedDataManagement/GetEventNameById`, new ObjectHolder(eventId)).pipe(catchError(this.handleError)));
            if (result) {
                await this.setSelectedEvent(result.item1, result.item2);
            }
        }
    }

    public getBreeds(showingActive: boolean, breedList: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetBreeds?showingActive=' + showingActive, breedList)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateBreed(breed: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateBreed', breed)
            .pipe(catchError(this.handleError));
    }

    public getBreedCountries(breedId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetBreedCountries?breedId=' + breedId)
            .pipe(catchError(this.handleError));
    }

    public getSpeciesList() {
        return this._http
            .get<ISpecies[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesList')
            .pipe(catchError(this.handleError));
    }

    public getBreedData(breedId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetBreedData?breedId=' + breedId)
            .pipe(catchError(this.handleError));
   }

   public getCaptureTypeList() {
      return this._http
         .get<ICaptureType[]>(this.myAppUrl + 'api/SharedDataManagement/GetCaptureTypeList')
         .pipe(catchError(this.handleError));
   }

    public getCountries(showingActive: boolean, countryList: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetCountries?showingActive=' + showingActive, countryList)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateCountry(country: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateCountry', country)
            .pipe(catchError(this.handleError));
    }

    public getCountryData(countryId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetCountryData?countryId=' + countryId)
            .pipe(catchError(this.handleError));
    }

    public getProducts(showingActive: boolean, productList: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetProducts?showingActive=' + showingActive, productList)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateProduct(product: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateProduct', product)
            .pipe(catchError(this.handleError));
    }

    public getProductData(productId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetProductData?productId=' + productId)
            .pipe(catchError(this.handleError));
    }

    public getProductCountries(productId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetProductCountries?productId=' + productId)
            .pipe(catchError(this.handleError));
    }

    public getSampleIssues(showingActive: boolean, sampleIssueList: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/getSampleIssues?showingActive=' + showingActive, sampleIssueList)
            .pipe(catchError(this.handleError));
    }

    public getSampleIssuesByTest() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSampleIssuesByTest?testId=' + this.getSelectedTestId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSampleIssueData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSampleIssueData?sampleIssueOptionID=' + id)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSampleIssue(sampleIssue: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/addOrUpdateSampleIssue', sampleIssue)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSampleIssueImages(sampleIssueImages: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/addOrUpdateSampleIssueImages?sampleIssueOptionID=' + this.getSelectedSampleIssueId, sampleIssueImages)
            .pipe(catchError(this.handleError));
    }

    public getTestsBySampleIssue() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetTestsBySampleIssue?sampleIssueOptionID=' + this.getSelectedSampleIssueId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSampleIssueImagesData() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSampleIssueImagesData?sampleIssueOptionID=' + this.getSelectedSampleIssueId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateSampleIssueTests(tests: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateSampleIssueTests?sampleIssueOptionID=' + this.getSelectedSampleIssueId, tests)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSpecies(showingActive: boolean, specieList: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetSpecies?showingActive=' + showingActive, specieList)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSpecie(specie: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateSpecie', specie)
            .pipe(catchError(this.handleError));
    }

    public getSpecieData(speciesId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSpecieData?speciesId=' + speciesId)
            .pipe(catchError(this.handleError));
    }

    public getStockClasss(showingActive: boolean, stockClassList: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetStockClasses?showingActive=' + showingActive, stockClassList)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateStockClass(stockClass: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateStockClass', stockClass)
            .pipe(catchError(this.handleError));
    }

    public getStockClassData(stockClassId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetStockClassData?stockClassId=' + stockClassId)
            .pipe(catchError(this.handleError));
    }

    public getStockClassCountries(stockClassId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetStockClassCountries?stockClassId=' + stockClassId)
            .pipe(catchError(this.handleError));
    }

    public getInheritableCountriesList() {
        return this._http
            .get<ICountry[]>(this.myAppUrl + 'api/SharedDataManagement/GetInheritableCountriesList')
            .pipe(catchError(this.handleError));
    }

    public getGenderList() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetGenderList')
            .pipe(catchError(this.handleError));
    }

    public getNumberOfCountries() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfCountries')
            .pipe(catchError(this.handleError));
    }

    public getNumberOfProducts() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfProducts')
            .pipe(catchError(this.handleError));
    }

    public getNumberOfSampleIssues() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfSampleIssues')
            .pipe(catchError(this.handleError));
    }

    public getNumberOfSeasons() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfSeasons')
            .pipe(catchError(this.handleError));
    }

    public getNumberOfSpecies() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfSpecies')
            .pipe(catchError(this.handleError));
    }

    public getRegions(showingActive: boolean, options: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetRegions?countryId=' + this.getSelectedCountryId + '&showingActive=' + showingActive, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateRegion(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateRegion', data)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getRegionData(id: number) {
        return this._http
            .get<Region>(this.myAppUrl + 'api/SharedDataManagement/GetRegionData?regionID=' + id)
            .pipe(
                catchError(this.handleError)
            );
    }
    public getDisclaimers(disclaimerList: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetDisclaimers', disclaimerList)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateDisclaimer(disclaimer: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateDisclaimer', disclaimer)
            .pipe(
                catchError(this.handleError)
            );
    }

    public submitProductStyle(styleID: number) {
        return this._http
            .get<number>(this.myAppUrl + "api/WhiteLabel/AddOrUpdateProductStyle?styleId=" + styleID + '&productId=' + this._navService.selectedAccounts.getSelectedProductId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getProductStyleID() {
        return this._http
            .get<number>(this.myAppUrl + "api/WhiteLabel/GetProductStyleID?productId=" + this._navService.selectedAccounts.getSelectedProductId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public canProductWhiteLabel(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/SharedDataManagement/ProductCanWhiteLabel?productID=" + this._navService.selectedAccounts.getSelectedProductId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSeasons(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetSeasons?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSeason(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateSeason', data)
            .pipe(catchError(this.handleError));
    }

    public getSeasonData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSeasonData?seasonID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getDisclaimerData(disclaimerID: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetDisclaimerData?disclaimerID=' + disclaimerID)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getGlobalDisclaimer() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetGlobalDisclaimer')
            .pipe(
                catchError(this.handleError)
            );
    }

    public getStockConditions(showingActive: boolean, stockConditionList: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetStockConditions?showingActive=' + showingActive, stockConditionList)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateStockCondition(stockCondition: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateStockCondition', stockCondition)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getStockConditionData(stockConditionId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetStockConditionData?stockConditionId=' + stockConditionId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEvents(groupId: number, siteId: number, showingActive: boolean, eventList: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetEvents?groupId=' + groupId + '&siteId=' + siteId + '&showingActive=' + showingActive, eventList)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateEvent(event: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateEvent', event)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateEventMessage(eventMessage: any) {
        return this._http
            .post<EventMessage>(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateEventMessage', eventMessage)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEventData(eventId: number, groupId: number | null, siteId: number | null) {
        return this._http
            .post<Event>(this.myAppUrl + 'api/SharedDataManagement/GetEventData', {item1: eventId, item2: groupId, item3: siteId})
            .pipe(
                catchError(this.handleError)
            );
    }

    public getFrequencies() {
        return this._http
            .get<IFrequency[]>(this.myAppUrl + 'api/SharedDataManagement/GetFrequencies')
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEventMessageData(id: number) {
        return this._http
            .get<EventMessage>(this.myAppUrl + 'api/SharedDataManagement/GetEventMessageData?eventID=' + id)
            .pipe(catchError(this.handleError));
    }
    
    // Species events 

    public updateSpeciesEvents(events: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateSpeciesEvents?speciesId=' + this.getSelectedSpeciesId, events)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEventsBySpecies() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetEventsBySpecies?speciesId=' + this.getSelectedSpeciesId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateEventSpecies(eventId: number, species: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateEventSpecies?eventId=' + eventId, species)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSpeciesByEvent(eventId: number) {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesByEvent?eventId=' + eventId)
            .pipe(
                catchError(this.handleError)
            );
    }

    // Country events


    public updateCountryEvents(events: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateCountryEvents?countryId=' + this.getSelectedCountryId, events)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEventsByCountry() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetEventsByCountry?countryId=' + this.getSelectedCountryId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateEventCountry(eventId: number, species: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateEventCountry?eventId=' + eventId, species)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getCountriesByEvent(eventId: number) {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetCountriesByEvent?eventId=' + eventId)
            .pipe(
                catchError(this.handleError)
            );
    }

    // Season events 

    public updateSeasonEvents(events: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateSeasonEvents?seasonId=' + this.getSelectedSeasonId, events)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getEventsBySeason() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetEventsBySeason?seasonId=' + this.getSelectedSeasonId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateEventSeason(eventId: number, seasons: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateEventSeason?eventId=' + eventId, seasons)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSeasonsByEvent(eventId: number) {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSeasonsByEvent?eventId=' + eventId)
            .pipe(
                catchError(this.handleError)
            );
    }

    // Start of tests
    public get getSelectedTestId() {
        return this._navService.selectedAccounts.getSelectedTestId;
    }

    public get getSelectedTestName() {
        return this._navService.selectedAccounts.getSelectedTestName;
    }

    public setSelectedTest(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedTest(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedTest() {
        if (this._navService.selectedAccounts.getSelectedTestId) {
            this._navService.selectedAccounts.clearSelectedTest();
            this._navService.updateNavCounts();
        }
    }
    
    public get getSelectedSubscriptionId() {
        return this._navService.selectedAccounts.getSelectedSubscriptionId;
    }

    public get getSelectedSubscriptionName() {
        return this._navService.selectedAccounts.getSelectedSubscriptionName;
    }

    public setSelectedSubscription(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedSubscription(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedSubscription() {
        if (this._navService.selectedAccounts.getSelectedSubscriptionId) {
            this._navService.selectedAccounts.clearSelectedSubscription();
            this._navService.updateNavCounts();
        }
    }

    public getTests(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetTests?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateTest(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateTest', data)
            .pipe(catchError(this.handleError));
    }

    public getTestData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetTestData?testID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfTests() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfTests')
            .pipe(catchError(this.handleError));
    }

   public sampleIssueIsOther(): Observable<boolean> {
      return this._http
         .get<boolean>(this.myAppUrl + "api/SharedDataManagement/SampleIssueIsOther?sampleIssueOptionId=" + this.getSelectedSampleIssueId)
         .pipe(
            catchError(this.handleError)
         );
   }

    public updateTestSampleIssues(sampleIssues: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/updateTestSampleIssues?testId=' + this.getSelectedTestId, sampleIssues)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateTestSpecies(species: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateTestSpecies?testId=' + this.getSelectedTestId, species)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSpeciesByTest() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesByTest?testId=' + this.getSelectedTestId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateTestAvailability(test: Test) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateTestAvailability', test)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateTestCountry(species: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateTestCountry?testId=' + this.getSelectedTestId, species)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getCountriesByTest() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetCountriesByTest?testId=' + this.getSelectedTestId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getTestsBySpecies() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetTestsBySpecies?speciesID=' + this.getSelectedSpeciesId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateSpeciesTests(tests: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateSpeciesTests?speciesID=' + this.getSelectedSpeciesId, tests)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getTestsByCountry() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetTestsByCountry?countryID=' + this.getSelectedCountryId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateCountryTests(tests: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateCountryTests?countryID=' + this.getSelectedCountryId, tests)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSubscriptions(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetSubscriptions?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSubscription(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateSubscription', data)
            .pipe(catchError(this.handleError));
    }

    public getSubscriptionEditData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSubscriptionEditData?subscriptionTypeID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getSubscriptionViewData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSubscriptionViewData?subscriptionTypeID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getSubscriptionPricings(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetSubscriptionPricings?subscriptionTypeID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getCurrencies(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetCurrencies?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateCurrency(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateCurrency', data)
            .pipe(catchError(this.handleError));
    }

    public getCurrencyData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetCurrencyData?currencyID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfCurrencies() {
        return this._http
            .get<number>(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfCurrencies')
            .pipe(catchError(this.handleError));
    }
    
    public getCurrencyByCountry(countryId: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetCurrencyByCountry?countryId=' + countryId)
            .pipe(catchError(this.handleError));
    }
    
    public getAttributes(showingActive: boolean, options: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetAttributes?subscriptionTypeId=' + this.getSelectedSubscriptionId + '&showingActive=' + showingActive, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdateAttribute(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateAttribute', data)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getAttributeData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetAttributeData?subscriptionTypeAttributeID=' + id)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getPermPricings(showingActive: boolean, options: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetPermPricings?subscriptionTypeId=' + this.getSelectedSubscriptionId + '&showingActive=' + showingActive, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getVacantCountries(countryID: number | null = null) {
        return this._http
            .get(`${this.myAppUrl}api/SharedDataManagement/GetVacantCountries?subscriptionTypeId=${this.getSelectedSubscriptionId}&countryId=${countryID != null ? countryID : 0}`)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getPricingCountries() {
        return this._http
            .get(`${this.myAppUrl}api/SharedDataManagement/GetPricingCountries`)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getTempPricings(showingActive: boolean, options: DataList) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/GetTempPricings?subscriptionTypeId=' + this.getSelectedSubscriptionId + '&showingActive=' + showingActive, options)
            .pipe(
                catchError(this.handleError)
            );
    }

    public addOrUpdatePricing(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdatePricing', data)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getPricingData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetPricingData?subscriptionTypePricingID=' + id)
            .pipe(
                catchError(this.handleError)
            );
    }

    // End of tests

    public getSpeciesImages() {
        return this._http
            .get<ImageFile[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesImages')
            .pipe(
                catchError(this.handleError)
            );
    }

    public addSpeciesImage(image: ImageFile) {
        try {
            return this._http.post<ImageFile>(`api/SharedDataManagement/AddSpeciesImage`, image)
                .pipe(
                    catchError(this.handleError)
                );
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    public getTimezones() {
        return this._http.get<Timezone[]>(`api/SharedDataManagement/GetTimezones`)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getParticles(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetParticles?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateParticle(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateParticle', data)
            .pipe(catchError(this.handleError));
    }

    public getParticleData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetParticleData?particleID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfParticles() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfParticles')
            .pipe(catchError(this.handleError));
    }

    public updateParticleCountry(countries: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateParticleCountry?particleID=' + this.getSelectedParticleId, countries)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getCountriesByParticle() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetCountriesByParticle?particleID=' + this.getSelectedParticleId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateParticleParticleGroup(groups: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateParticleParticleGroup?particleID=' + this.getSelectedParticleId, groups)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getParticleGroupsByParticle() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetParticleGroupsByParticle?particleID=' + this.getSelectedParticleId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateSpeciesParticle(species: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateSpeciesParticle?particleID=' + this.getSelectedParticleId, species)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getSpeciesByParticle() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesByParticle?particleID=' + this.getSelectedParticleId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getImagesByParticle() {
        return this._http
            .get<ExampleImage[]>(this.myAppUrl + 'api/SharedDataManagement/GetImagesByParticle?particleID=' + this.getSelectedParticleId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateParticleImages(images: ExampleImage[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateParticleImages?particleID=' + this.getSelectedParticleId, images)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getParticleSpecies(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetParticleSpecies?particleID=' + this.getSelectedParticleId + '&showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateParticleSpecies(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateParticleSpecies?particleID=' + this.getSelectedParticleId, data)
            .pipe(catchError(this.handleError));
    }

    public getParticleSpeciesData(id: number) {
        return this._http
            .get<SpeciesParticle>(this.myAppUrl + 'api/SharedDataManagement/GetParticleSpeciesData?speciesParticleID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfParticleSpecies() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfParticleSpecies?particleID=' + this.getSelectedParticleId)
            .pipe(catchError(this.handleError));
    }

    public getSpeciesNotOfParticle(speciesParticleID: number | null = null) {
        return this._http
            .get<ISpecies[]>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesNotOfParticle?particleID=' + this.getSelectedParticleId + '&speciesParticleID=' + speciesParticleID)
            .pipe(catchError(this.handleError));
    }

    public getSpeciesParticles(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetSpeciesParticles?speciesID=' + this.getSelectedSpeciesId + '&showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateSpeciesParticle(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateSpeciesParticle?speciesID=' + this.getSelectedSpeciesId, data)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfSpeciesParticles() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfSpeciesParticles?speciesID=' + this.getSelectedSpeciesId)
            .pipe(catchError(this.handleError));
    }

    public getParticlesList(speciesParticleID: number | null = null) {
        return this._http
            .get<ISpecies[]>(this.myAppUrl + 'api/SharedDataManagement/GetParticlesList?speciesID=' + this.getSelectedSpeciesId + '&speciesParticleID=' + speciesParticleID)
            .pipe(catchError(this.handleError));
    }

    public isDuplicateWithSameDate(particleID: number | null, date: Date): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + 'api/SharedDataManagement/IsDuplicateWithSameDate?speciesID=' + this.getSelectedSpeciesId + '&particleID=' + particleID + '&startDate=' + date)
            .pipe(catchError(this.handleError));
    }

    public getParticleGroups(showingActive: boolean, options: DataList) {
        return this._http
            .post<IListType>(this.myAppUrl + 'api/SharedDataManagement/GetParticleGroups?showingActive=' + showingActive, options)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateParticleGroup(data: any) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/AddOrUpdateParticleGroup', data)
            .pipe(catchError(this.handleError));
    }

    public getParticleGroupData(id: number) {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetParticleGroupData?particleGroupID=' + id)
            .pipe(catchError(this.handleError));
    }

    public getNumberOfParticleGroups() {
        return this._http
            .get(this.myAppUrl + 'api/SharedDataManagement/GetNumberOfParticleGroups')
            .pipe(catchError(this.handleError));
    }

    public getParticlesByCountry() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetParticlesByCountry?countryID=' + this.getSelectedCountryId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateCountryParticles(particles: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateCountryParticles?countryID=' + this.getSelectedCountryId, particles)
            .pipe(
                catchError(this.handleError)
            );
    }

    public updateParticleGroupParticles(particles: number[]) {
        return this._http
            .post(this.myAppUrl + 'api/SharedDataManagement/UpdateParticleGroupParticles?particleGroupID=' + this.getSelectedParticleGroupId, particles)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getParticlesByParticleGroup() {
        return this._http
            .get<any[]>(this.myAppUrl + 'api/SharedDataManagement/GetParticlesByParticleGroup?particleGroupID=' + this.getSelectedParticleGroupId)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getCountryProviders(showingActive: boolean, options: DataList) {
        if (this.getSelectedCountryId) {
            return this._http
                .post(`api/SharedDataManagement/GetCountryProviders?countryId=${this.getSelectedCountryId}&showingActive=` + showingActive, options)
                .pipe(
                    catchError(this.handleError)
                );
        }
        
        return null;
    }
    
    public addOrUpdateProvider(provider: Provider) {
        if (this.getSelectedCountryId) {
            return this._http
                .post<boolean>(this.myAppUrl + `api/SharedDataManagement/AddOrUpdateProvider?countryId=${this.getSelectedCountryId}`, provider)
                .pipe(
                    catchError(this.handleError)
                );
        }
        
        return null;
    }
    
    public getProviderData(providerID: number) {
        return this._http
            .post<Provider>('api/SharedDataManagement/GetProviderData', providerID)
            .pipe(
                catchError(this.handleError)
            );
    }

    public getGlobalPostTreatmentCalcDetails() {
        return this._http
            .post<PostTreatmentCalculator>(`api/SharedDataManagement/GetGlobalPostTreatmentCalcDetails`, null)
            .pipe(catchError(this.handleError));
    }

    public addOrUpdateGlobalPostTreatmentCalc(model: PostTreatmentCalculator) {
        return this._http
            .post<boolean>(`api/SharedDataManagement/AddOrUpdateGlobalPostTreatmentCalc`, model)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }
}
